import React, { useState, useEffect } from "react";
import axios from "axios";
import Navbar from "./Navbar";
import Footer from "./Footer";

const API = "https://course-selling-backend-2-rr1n.onrender.com";

function EditCourse() {
  const [courses, setCourses] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const [form, setForm] = useState({
    title: "",
    description: "",
    price: "",
    discount: "",
    thumbnail: "",
  });

  // ✅ Fetch courses (Admin only)
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      alert("Please login as admin to edit or delete courses.");
      return;
    }

    axios
      .get(`${API}/api/courses/`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setCourses(res.data))
      .catch((err) => {
        console.error("Error fetching courses:", err);
        alert("Failed to load courses. Please check admin access or token validity.");
      });
  }, []);

  const handleSelect = (id) => {
    const course = courses.find((c) => c._id === id);
    setSelectedId(id);
    setForm(course);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // ✅ Update Course
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(
        `${API}/api/courses/update/${selectedId}`,
        {
          title: form.title,
          description: form.description,
          price: Number(form.price),
          discount: Number(form.discount),
          thumbnail: form.thumbnail,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      alert("✅ Course updated successfully!");
    } catch (err) {
      console.error("Error updating course:", err);
      alert("❌ Update failed. Check console or backend logs.");
    }
  };

  // 🗑️ Delete Course
  const handleDelete = async () => {
    if (!selectedId) return alert("Please select a course to delete!");
    if (!window.confirm("⚠️ Are you sure you want to delete this course?")) return;

    try {
      await axios.delete(`${API}/api/courses/delete/${selectedId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      alert("🗑️ Course deleted successfully!");
      setCourses(courses.filter((c) => c._id !== selectedId));
      setSelectedId("");
      setForm({
        title: "",
        description: "",
        price: "",
        discount: "",
        thumbnail: "",
      });
    } catch (err) {
      console.error("Error deleting course:", err);
      alert("❌ Delete failed. Check console or backend logs.");
    }
  };

  return (
    <>
      <Navbar />
      
    <div style={{ padding: "20px" }}>
      <h2>Edit or Delete Course</h2>

      {/* Select course */}
      <select onChange={(e) => handleSelect(e.target.value)} value={selectedId}>
        <option value="">Select a course</option>
        {courses.map((c) => (
          <option key={c._id} value={c._id}>
            {c.title}
          </option>
        ))}
      </select>

      {selectedId && (
        <form onSubmit={handleSubmit} style={{ marginTop: "20px" }}>
          <input
            type="text"
            name="title"
            value={form.title}
            onChange={handleChange}
            placeholder="Course Title"
          />
          <textarea
            name="description"
            value={form.description}
            onChange={handleChange}
            placeholder="Description"
          />
          <input
            type="number"
            name="price"
            value={form.price}
            onChange={handleChange}
            placeholder="Price"
          />
          <input
            type="number" style={{ color: "black" , boder : "black"}}
            name="discount"
            value={form.discount}
            onChange={handleChange}
            placeholder="Discount" 
          />
          <input
            type="text"
            name="thumbnail"
            value={form.thumbnail}
            onChange={handleChange}
            placeholder="Thumbnail URL"
          />
           <input
            type="text"
            name="video"
            value={form.videos}
            onChange={handleChange}
            placeholder="Video URL"
          />
          <div style={{ marginTop: "10px" }}>
            <button type="submit" style={{ marginRight: "10px" }}>
              💾 Update Course
            </button>
            <button
              type="button"
              onClick={handleDelete}
              style={{ backgroundColor: "red", color: "white" }}
            >
              🗑️ Delete Course
            </button>
          </div>
        </form>
      )}
      
    </div>
    <Footer />
    </>
   
    
  );
}

export default EditCourse;
